<template>
  <div>
    <back-btn/>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card class="card--shadow">
            <vlu-list :volunteers="volunteers" :trash="true" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import VluList from "@/components/volunteer/VluList";

import { mapState } from "vuex";
import BackBtn from '@/components/navigation/BackBtn';

export default {
  components: {
    VluList,
    BackBtn
  },
  computed: {
    ...mapState("Volunteer", ["volunteers"])
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      let payload = {};
      this.$store.dispatch("Volunteer/getTrashedVolunteer", payload);
    }
  },
  watch: {
    $route() {
      this.getData();
    }
  }
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
